import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Tooltip from '@components/Tooltip/Tooltip'
import InfoIcon from '@components/Icon/Info'
import CopyButton from '@components/CopyButton'

const Row = ({
  label,
  tooltip,
  tooltipPlacement,
  children,
  text,
  onClick,
  mailTo,
  externalLink,
  noLabel,
  copiable,
  boldText = false
}) => {
  return (
    <div className='row'>
      {renderLabel(noLabel, label, tooltip, tooltipPlacement)}
      {children || renderValue(text, mailTo, externalLink, onClick, boldText)}
      {renderCopyButton(copiable, text)}
    </div>
  )
}

export default observer(Row)

Row.propTypes = {
  text: PropTypes.string,
  mailTo: PropTypes.bool,
  children: PropTypes.element,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  label: PropTypes.string,
  externalLink: PropTypes.string,
  noLabel: PropTypes.bool,
  copiable: PropTypes.bool,
  boldText: PropTypes.bool,
}

const renderLabel = (noLabel, label, tooltip, tooltipPlacement) => {
  if (noLabel) return

  return label ? (
    <span className='row__name'>
      {label}: {tooltip && renderTooltip(tooltip, tooltipPlacement)}
    </span>
  ) : (
      <span className='row__name' />
    )
}

const renderCopyButton = (copiable, value) => {
  if (copiable) {
    return <CopyButton small value={value} />
  }
}

const renderValue = (text, mailTo, externalLink, onClick, boldText) => {
  if (!text && !externalLink) {
    return <span className='row__value'>-</span>
  }

  let rowValue = text
  if (mailTo) {
    rowValue = <a href={`mailto:${text}`}>{text}</a>
  }
  if (externalLink) {
    rowValue = (
      <a href={externalLink} target='_blank' rel='noopener noreferrer'>
        {externalLink}
      </a>
    )
  }

  if (onClick) {
    return (
      <span className='row__value row--link' onClick={onClick}>
        {text}
      </span>
    )
  }

  return boldText ? <strong className='row__value'>{rowValue}</strong> : <span className='row__value'>{rowValue}</span>
}

const renderTooltip = (tooltip, tooltipPlacement) => {
  return (
    <Tooltip tooltip={tooltip} placement={tooltipPlacement || 'topLeft'}>
      <div className='row__info-icon'>
        <InfoIcon />
      </div>
    </Tooltip>
  )
}
